import {db} from "@/db";
import {utils} from "@/utils/utils";

const sp = require("swiss-pairing")({
    maxPointsPerRound: 1
})

const robin = require("roundrobin");

export const rounds = {

    // change the "add next round button to this one for simple round robins
    getRoundRobin: function (store, className) {
        console.log(("getRoundRobin started"))
        let roundNumber = store.state.rounds.length
        let race = {};
        const round = {};
        round.number = roundNumber;
        round.races = [];
        const allRounds = robin(8);
        if (roundNumber > 6) {
            roundNumber = 0
        }
        allRounds[roundNumber].forEach((matchUp) => {
            race = {};
            race.team1 = this.getTeamFromId(store, matchUp[0] + "");
            race.team1.teamId = race.team1.id;
            race.team2 = this.getTeamFromId(store, matchUp[1] + "");
            race.team2.teamId = race.team2.id;
            race.team1Boat = store.state.boatGroups[matchUp[0] - 1];
            race.team2Boat = store.state.boatGroups[matchUp[1] - 1];
            round.races.push(race);
        });
        if (round.races.length > 0) {
            // save the new round
            round.className = className;
            round.lastBoatGroupIndex = store.getters.getBoatGroupIndex;
            return this.setRoundsFirestore(store, round).then(() => {
                console.log('firebase updated')
            });
        }

    },

    getMatchUps: function (store, className) {
        console.log(("getMatchUps started"))
        let roundNumber = store.state.rounds.length + 1
        if (roundNumber === 3 && store.state.rounds[1].races.length < store.state.teams.length / 2) { // round 2 still going
            roundNumber = 2;
        }
        if (roundNumber === 1) {
            // make sure colours of first round always start with first Group
            store.commit("resetBoatGroupIndex");
        }
        console.log("round number: " + roundNumber)
        let matchUps;
        // special rules for round 1
        if (roundNumber === 1) {
            matchUps = this.getRoundOneMatchUps(store)
        } else if (roundNumber === 2) {
            matchUps = this.getRoundTwoMatchUps(store)
        } else {
            const participants = utils.getParticipants(store, roundNumber);
            const results = utils.getResults(store);
            matchUps = sp.getMatchups(roundNumber, participants, results)
        }

        let round = {};
        if (roundNumber === 2 && store.state.rounds[1]) {
            round = store.state.rounds[1];
        } else {
            round = {};
            round.number = roundNumber;
            round.races = [];
        }

        let race;
        // make sure we pick up the boatGroup from the previous race
        if (round.races.length > 0 && matchUps.length > 0) {
            store.commit("updateBoatGroupIndex", store.state.rounds[roundNumber - 1].lastBoatGroupIndex)
        } // make sure we pick up the boatGroup from the previous round
        else if (roundNumber > 1 && matchUps.length > 0) {
            store.commit("updateBoatGroupIndex", store.state.rounds[roundNumber - 2].lastBoatGroupIndex)
        }
        matchUps.forEach((matchUp) => {
            race = {};
            race.team1 = this.getTeamFromId(store, matchUp.away);
            race.team1.teamId = race.team1.id;
            race.team2 = this.getTeamFromId(store, matchUp.home);
            race.team2.teamId = race.team2.id;
            race.team1Boat = store.state.boatGroups[store.getters.getBoatGroupIndex];
            store.commit("incrementBoatGroupIndex");
            race.team2Boat = store.state.boatGroups[store.getters.getBoatGroupIndex];
            store.commit("incrementBoatGroupIndex");
            round.races.push(race);
        });
        console.log("round.races.length: "+round.races.length)
        if (round.races.length > 0) {
            // save the new round
            round.className = className;
            round.lastBoatGroupIndex = store.getters.getBoatGroupIndex;
            return this.setRoundsFirestore(store, round).then(() => {
                console.log('firebase updated')
            });
        }
        /*        if(roundNumber===2 && round.races && round.races.length===store.state.teams.length/2){
                    // force third round to load
                    teams.updateStandings(store, round)
                    console.log("Last round saved -> standings updated!")
                    rounds.getMatchUps(store, className)
                    console.log("Last round saved -> new round added")
                }*/
    },

    getRoundTwoMatchUps: function (store) {
        const matchUps = [];
        let winners = (!store.state.rounds[1] || !store.state.rounds[1].races || store.state.rounds[1].races.length === 0)
            || (store.state.rounds[1] && store.state.rounds[1].races && store.state.rounds[1].races.length % 2 === 0);
        for (let i = 0; i < store.state.rounds[0].races.length; i++) {
            if (i === store.state.rounds[0].races.length - 1 && store.state.rounds[0].races[i].result) {  // special case for last round
                matchUps.push({
                    "away": store.state.rounds[0].races[i].loser,
                    "home": store.state.rounds[0].races[0].loser
                });
            } else if (store.state.rounds[0].races[i].result
                && store.state.rounds[0].races[i + 1]
                && store.state.rounds[0].races[i + 1].result
                && (!store.state.rounds[1] || !store.state.rounds[1].races[i])) {
                // ok so we've found a round we need to add and enough of the previous rounds have finished, so we can
                if (winners) {
                    matchUps.push({
                        "away": store.state.rounds[0].races[i].winner,
                        "home": store.state.rounds[0].races[i + 1].winner
                    });
                } else {
                    matchUps.push({
                        "away": store.state.rounds[0].races[i].loser,
                        "home": store.state.rounds[0].races[i + 1].loser
                    });
                }

                winners = !winners;
            }

        }
        return matchUps;
    },


    getRoundOneMatchUps: function (store) {
        const matchUps = [];
        const participants = utils.getParticipants(store, 1);
        for (let i = 0; i < participants.length; i += 2) {
            matchUps.push({"away": participants[i].id, "home": participants[i + 1].id});
        }
        return matchUps;
    },

    getTeamFromName: function (store, teamName) {
        return store.state.teams.find(team => team.name === teamName);
    },
    getTeamFromId: function (store, teamId) {
        console.log("teamId: "+store.state.teams.find(team => team.id === teamId))
        return store.state.teams.find(team => team.id === teamId);
    },

    getRounds: function (store) {
        db.collection("events/" + store.state.event.id + "/" + rounds)
            .get()
            .then(querySnapshot => {
                store.commit('updateRounds', querySnapshot.docs.map(doc => doc.data()))
                // do something with documents
            })
    },

    setRoundsFirestore: function (store, round) {
        // return the promise so we can await this action
        return db.collection(`events/${store.state.event.id}/rounds`)
            .doc(round.className + "_" + round.number)
            .set(round)
            .then(() => {
                console.log('set rounds!')
            })
    },

}


